var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',{attrs:{"data-uk-tab":"connect: #element-settings; animation: uk-animation-slide-right-medium"}},[_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Inhalt")])]),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Einstellungen")])])])])
}]

export { render, staticRenderFns }